import { RootState } from "../../utils/types"

export const usersSelector = (state: RootState) =>
  state.users.map


export const usersStatusSelector = (state: RootState) => state.users.status